// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__mr826","location":"Header_location__3-Phn"};